import { render, staticRenderFns } from "./homeJoinpeople.vue?vue&type=template&id=20c3bf1b&scoped=true&"
import script from "./homeJoinpeople.vue?vue&type=script&lang=js&"
export * from "./homeJoinpeople.vue?vue&type=script&lang=js&"
import style0 from "./homeJoinpeople.vue?vue&type=style&index=0&id=20c3bf1b&prod&lang=less&scoped=true&"
import style1 from "./homeJoinpeople.vue?vue&type=style&index=1&id=20c3bf1b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3bf1b",
  null
  
)

export default component.exports